import React from 'react';

// Clean labeled stat tiles. Every number here is provable: repo counts come
// from the public SHAILY24 GitHub account, the live count from HOSTING.md
// (8 original demos + vcard + mbridge + cea + the two labelled ones), the
// model accuracies and review count from the repo-backed metric inventory.
// No career metric appears here.

const TILES = [
  { v: '17', l: 'public repositories', m: 'github.com/SHAILY24' },
  { v: '13', l: 'live demos', m: 'each one clickable' },
  {
    v: '77.5 / 78.5 / 76.5',
    l: 'banking model accuracy %',
    m: 'RF / XGBoost / NN',
  },
  { v: '~515,738', l: 'hotel reviews analyzed', m: 'NLP + segmentation' },
];

export default function StatTiles() {
  return (
    <div className="stat-tiles" role="list" aria-label="Provable figures">
      {TILES.map((t) => (
        <div className="stat-tile" role="listitem" key={t.l}>
          <span className="sv num">{t.v}</span>
          <span className="sl">{t.l}</span>
          <span className="sm">{t.m}</span>
        </div>
      ))}
    </div>
  );
}
